<h2 mat-dialog-title>Add new A/C Type</h2>
<form [formGroup]="newTypeForm">
  <mat-dialog-content class="parameter-fields-container">
    @if(errorMessage){
    <div class="error-message">{{ errorMessage }}</div>
    }
    <mat-form-field>
      <mat-label>IATA Type</mat-label>
      <input matInput formControlName="iataType" name="IATA" />
      @if(newTypeForm.controls.iataType.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 5" }}</mat-error>
      } @if(newTypeForm.controls.iataType.hasError('pattern') &&
      newTypeForm.controls.iataType.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>ICAO Type</mat-label>
      <input matInput formControlName="icaoType" name="ICAO" />
      @if(newTypeForm.controls.icaoType.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 5" }}</mat-error>
      } @if(newTypeForm.controls.icaoType.hasError('pattern') &&
      newTypeForm.controls.icaoType.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>A/C TYPE SCHED</mat-label>
      <input matInput formControlName="sched" name="sched" />
      @if(newTypeForm.controls.sched.hasError('maxlength')){
        <mat-error>{{ "Maximum number of characters is 5" }}</mat-error>
      } @if(newTypeForm.controls.sched.hasError('pattern') &&
    newTypeForm.controls.sched.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
    }
    </mat-form-field>
    <mat-form-field>
      <mat-label>AVG FUEL CONS PER BH</mat-label>
      <input matInput formControlName="avgFuelConsPerBh" name="avgFuelConsPerBh" />
      @if(newTypeForm.controls.avgFuelConsPerBh.hasError('maxlength')){
        <mat-error>{{ "Maximum number of characters is 6" }}</mat-error>
      } @if(newTypeForm.controls.avgFuelConsPerBh.hasError('pattern') &&
    newTypeForm.controls.avgFuelConsPerBh.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
    }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Tank Capacity</mat-label>
      <input matInput formControlName="tankCapacity" name="tankCapacity" />
      @if(newTypeForm.controls.tankCapacity.hasError('maxlength')){
      <mat-error>{{ "Maximum number of characters is 6" }}</mat-error>
      } @if(newTypeForm.controls.tankCapacity.hasError('pattern') &&
      newTypeForm.controls.tankCapacity.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Min on Block Diff</mat-label>
      <input matInput formControlName="minOnBlockDiff" name="minOnBlockDiff" />
      @if(newTypeForm.controls.minOnBlockDiff.hasError('maxlength')) {
      <mat-error>{{ "Maximum number of characters is 6" }}</mat-error>
      } @if(newTypeForm.controls.minOnBlockDiff.hasError('pattern') &&
      newTypeForm.controls.minOnBlockDiff.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-label>Max on Block Diff</mat-label>
      <input matInput formControlName="maxOnBlockDiff" name="maxOnBlockDiff" />
      @if(newTypeForm.controls.maxOnBlockDiff.hasError('maxlength')) {
      <mat-error>{{ "Maximum number of characters is 6" }}</mat-error>
      } @if(newTypeForm.controls.maxOnBlockDiff.hasError('pattern') &&
      newTypeForm.controls.maxOnBlockDiff.value){
      <mat-error>{{ "Invalid characters" }}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!newTypeForm.valid"
      (click)="addNewType()"
    >
      Add
    </button>
  </mat-dialog-actions>
</form>
